import CONST_STORAGE from 'constants/storage';

export const setStorageTestOnly = (item: string) =>
  localStorage.setItem(CONST_STORAGE.SYSTEM_CONFIG.TEST_ONLY, item);

export const getTestOnly = () =>
  localStorage.getItem(CONST_STORAGE.SYSTEM_CONFIG.TEST_ONLY) || 'false';

export const setStorageDaysLimitToReportDurable = (item: string) =>
  localStorage.setItem(
    CONST_STORAGE.SYSTEM_CONFIG.DAY_LIMIT_TO_REPORT_DURABLE,
    item,
  );

export const getDaysLimitToReportDurable = () =>
  localStorage.getItem(
    CONST_STORAGE.SYSTEM_CONFIG.DAY_LIMIT_TO_REPORT_DURABLE,
  ) || '5';
